import { QuestionComponentProps } from "..";

import { JobFunctionSubFunctionSelector } from "./components/JobFunctionSubFunctionSelector";

export function JobFunctionSubFunction({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <JobFunctionSubFunctionSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
